import { defineComponent as _defineComponent } from 'vue'
export interface Props extends FontAwesomeIconProps {
  size?: string;
  color?: string;
  opacity?: string | number;
}


import { computed } from 'vue';
import type { StyleValue } from 'vue/types/jsx';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/vue-fontawesome';

export type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

declare module 'vue/types/vue' {
  export interface Vue {
    Icon: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'Icon' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    size: null,
    color: null,
    opacity: null
  },
  setup(__props: any) {

const props = __props as {
  size?: string;
  color?: string;
  opacity?: string | number;
};

/**
 * `Icon` component properties.
 */


const style = computed(() => {
  const styles: StyleValue = {};

  if (props.size) {
    styles.fontSize = props.size;
  }

  if (props.color) {
    styles.color = props.color;
  }

  if (props.opacity) {
    styles.opacity = props.opacity;
  }

  return styles;
});

return { __sfc: true,props, style, FontAwesomeIcon }
}

})